<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <input type="color" #field class="form-control colorpicker" [id]="(id === null ? name : id)" [name]="name"
        [value]="value" [disabled]="readOnly" (input)="changeValue($event)" />
</ng-template>
<ng-template #showSpan>
    <span type="text d-block" #field [id]="(id === null ? name : id)"
        [style]="'background-color: ' + value + ';color: ' + value">
        {{value}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>


<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>